import Vue from 'vue';
import store from '@/store';
import ENV from './config';
// import { roles } from '@/shared/constants';

export default () => {
  return {
    items: [
      {
        name: Vue.prototype.$tk('nav.dashboard_nav_title'),
        url: '/dashboard',
        icon: 'icon-speedometer',
        // badge: {
        //   variant: 'primary',
        //   text: 'NEW'
        // }
      },

      ...(store.state.Auth.activeProjectId ? [
        {
          name: Vue.prototype.$tk('nav.detection_sets_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/detection_sets`,
          icon: 'fa fa-picture-o',
          // permissions: ['detection_sets.view'],
          canSee: (!!store.getters['Auth/activeProjectPermissions'].admin && !ENV.VUE_APP_DISABLE_DETECTIONS),
        },
        {
          name: Vue.prototype.$tk('nav.json_schemas_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/json_schemas`,
          icon: 'fa fa-code',
          // permissions: ['json_schemas.view'],
          // canSee: (!!store.getters['Auth/activeProjectPermissions'].admin && ENV.VUE_APP_DISABLE_DETECTIONS),
          canSee: (!!store.getters['Auth/isAdmin'] && !ENV.VUE_APP_DISABLE_DETECTIONS),
        },
        {
          name: Vue.prototype.$tk('nav.sample_sets_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/sample_sets`,
          icon: 'fa fa-picture-o',
          // permissions: ['label_sets.view'],
          canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
        },
        {
          name: Vue.prototype.$tk('nav.label_sets_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/label_sets`,
          icon: 'fa fa-object-group',
          // permissions: ['label_sets.view'],
          canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
        },
        {
          name: Vue.prototype.$tk('nav.ai_models_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/ai_models`,
          icon: 'fa fa-android',
          // permissions: ['ai_models.view'],
          canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
        },
        {
          name: Vue.prototype.$tk('nav.ai_jobs_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/ai_jobs`,
          // permissions: ['ai_jobs.view'],
          canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
        },
        {
          name: Vue.prototype.$tk('nav.time_logs_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/time_logs`,
          icon: 'fa fa-clock-o',
          // permissions: ['time_logs.view'],
          canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
        },
        {
          name: Vue.prototype.$tk('nav.project_users_list_title'),
          url: `/projects/${store.state.Auth.activeProjectId}/project_users`,
          icon: 'fa fa-users',
          // permissions: ['project_users.view'],
          canSee: !!store.getters['Auth/isAdmin'],
        },
      ] : []),
      {
        name: Vue.prototype.$tk('nav.tags_list_title'),
        url: '/tags',
        icon: 'fa fa-tags',
        // permissions: ['tags.view'],
        canSee: !!store.getters['Auth/activeProjectPermissions'].admin,
      },
      {
        name: Vue.prototype.$tk('nav.administration_nav_title'),
        url: '/administration',
        icon: 'icon-settings',
        canSee: !!store.getters['Auth/isAdmin'],
        disableOffline: true,

        children: [
          {
            name: Vue.prototype.$tk('nav.projects_list_title'),
            url: '/administration/projects',
            // permissions: ['projects.view'],
            canSee: !!store.getters['Auth/isAdmin'],

          },
          {
            name: Vue.prototype.$tk('nav.users_list_title'),
            url: '/administration/users',
            // permissions: ['users.view'],
            canSee: !!store.getters['Auth/isAdmin'],
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.roles_list_title'),
            url: '/administration/roles',
            // permissions: ['roles.view'],
            canSee: !!store.getters['Auth/isAdmin'],
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.audit_logs_list_title'),
            url: '/administration/audit-logs',
            // permissions: ['activities.view'],
            canSee: !!store.getters['Auth/isAdmin'],
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.languages_list_title'),
            url: '/administration/languages',
            // permissions: ['languages.view'],
            disableOffline: true,
            canSee: !!store.getters['Auth/isAdmin'],
          },
          {
            name: Vue.prototype.$tk('nav.translations_list_title'),
            url: '/administration/translations',
            // permissions: ['translations.view'],
            canSee: !!store.getters['Auth/isAdmin'],
            disableOffline: true,
          },
        ]
      },
      // GenCrud.0.stubpart (stub fragment will be generated bellow this line - do not delete this)
      // GenCrud.0.TimeLogs.stubinsert.start
      // GenCrud.0.TimeLogs.stubinsert.end
      // GenCrud.0.LabelObjectSets.stubinsert.start
      // {
      //   name: Vue.prototype.$tk('nav.label_object_sets_list_title'),
      //   url: '/label_object_sets',
      //   permissions: ['label_object_sets.view'],
      // },
      // GenCrud.0.LabelObjectSets.stubinsert.end

      // GenCrud.0.LabelSetTags.stubinsert.start
      // {
      //   name: Vue.prototype.$tk('nav.label_set_tags_list_title'),
      //   url: '/label_set_tags',
      //   permissions: ['label_set_tags.view'],
      // },
      // GenCrud.0.LabelSetTags.stubinsert.end

    ],
  };
};
